<template>
  <div class="tab-header">
    <div class="container-fluid">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item" :class="{'active': currentTab===0}">
          <router-link class="nav-link" to="/list-area">推薦名單</router-link>
        </li>

        <!-- 目前國壽通知正式環境開啟 -->
        <li class="nav-item" :class="{'active': currentTab===1}">
          <router-link class="nav-link" to="/list-area/precision-marketing">商品行銷</router-link>
        </li>

        <!-- 目前國壽通知正式環境開啟 -->
        <li class="nav-item" :class="{'active': currentTab===2}">
          <router-link class="nav-link" to="/list-area/service-right">服務/權益</router-link>
          <!-- <a v-else href="#tab-2" class="nav-link disabled" role="tab" data-toggle="tab">服務/權益</a> -->
        </li>
        <!-- 目前國壽通知正式環境開啟 -->
        <li class="nav-item" :class="{'active': currentTab===3}">
          <router-link  class="nav-link" to="/list-area/integrated-marketing">整合行銷</router-link>
          <!-- <a v-else href="#tab-3" class="nav-link disabled" role="tab" data-toggle="tab">整合行銷</a> -->
        </li>
        <!-- 目前國壽通知正式環境開啟 -->
        <li class="nav-item" :class="{'active': currentTab===4}">
          <router-link class="nav-link" to="/list-area/group-related">活動推廣</router-link>
          <!-- <a v-else href="#tab-4" class="nav-link disabled" role="tab" data-toggle="tab">集團相關</a> -->
        </li>
        <li class="nav-item" :class="{'active': currentTab===5}">
          <router-link class="nav-link" to="/list-area/decree-zone">法令專區</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import { commonMixin } from '@/mixins/common';

export default {
  name: "TabHeader",
  props: {
    currentTab: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      onDev: false,
      isOfficial: false,
    }
  },
  computed: {
    ...mapGetters([ 'CustInfo','HasHousingLoans'])
  },
  mounted() {
    this.onDev = process.env.NODE_ENV === 'development'
    this.isOfficial = window.location.href.includes('://mycrm')
  },
}
</script>

<style>

</style>
